import isNil from "lodash/isNil";
import omitBy from "lodash/omitBy";

// see https://stackoverflow.com/a/53050575/9488088
type NoNullishField<T> = T extends Date
  ? Date
  : { [P in keyof T]-?: NoNullishField<NonNullable<T[P]>> };

export const omitNullish = <T extends object>(obj: T): NoNullishField<T> => {
  return omitBy(obj, isNil) as unknown as NoNullishField<T>;
};
